var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_780_7430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.6278 24 12C24 5.37225 18.6278 0 12 0ZM11.8492 4.47225C14.0677 4.47225 15.8738 6.2505 15.8738 8.4375C15.8738 10.6237 14.0677 12.4028 11.8492 12.4028C9.62925 12.4028 7.82475 10.6237 7.82475 8.4375C7.82475 6.25125 9.63 4.47225 11.8492 4.47225ZM18.5895 18.0848C18.5895 19.5278 16.2345 19.5278 13.5075 19.5278H10.4925C7.65375 19.5278 5.41125 19.5278 5.41125 18.0855V17.7885C5.41125 15.03 7.6905 12.7853 10.4918 12.7853H13.5075C16.3095 12.7853 18.5895 15.0292 18.5895 17.7878V18.0855V18.0848Z",
    fill: "#2469EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5075 12.7852H10.4925C7.6905 12.7852 5.41125 15.0292 5.41125 17.7885V18.0855C5.41125 19.5277 7.65375 19.5277 10.4925 19.5277H13.5075C16.2345 19.5277 18.5895 19.5277 18.5895 18.0855V17.7885C18.5895 15.03 16.3095 12.7852 13.5075 12.7852ZM11.8493 12.4027C14.0685 12.4027 15.8738 10.6252 15.8738 8.43823C15.8738 6.25123 14.0685 4.47223 11.8493 4.47223C9.63 4.47223 7.82475 6.25198 7.82475 8.43823C7.82475 10.6245 9.63 12.4027 11.8493 12.4027Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_780_7430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic);
export default __webpack_public_path__ + "static/media/pic.2dba599174c73401c5451f71ff2556e6.svg";
export { ForwardRef as ReactComponent };